import {
  IFormikValues,
  IFormStep,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { uiSchema } from "./schema.reportProblem";
import { getInitialValues } from "./schema.reportProblem.utils";

export const reportProblemSchema =
  () => (): { formStepsSchema: IFormStep[]; initialValues: IFormikValues } => {
    const initialValues = getInitialValues();
    const formStepsSchema = [
      {
        uiSchema: uiSchema(),
      },
    ];

    return { formStepsSchema, initialValues };
  };
